
import { Chart, Plugin } from "chart.js/auto";

export const CHART_GREEN = "rgb(124, 156, 9)";
export const CHART_BLUE = "rgb(17, 146, 232)";
const CHART_DARK_GRAY = "rgba(101, 108, 114, 0)";
const CHART_LIGHT_GRAY = "rgba(217, 217, 217, 1)";
const CHART_FILL_GREEN = "rgba(124, 156, 9, 0.4)";
const CHART_TRANSPARENT_GREEN = "rgba(124, 156, 9, 0)";

export const verticalLine: Plugin = {
    id: "verticalLine",
    beforeDatasetsDraw(chart: Chart) {
        const { ctx, chartArea: { top, bottom } } = chart;
        ctx.save();
        const gradient = ctx.createLinearGradient(0, bottom, 0, top);
        gradient.addColorStop(1, CHART_DARK_GRAY);
        gradient.addColorStop(0.5, CHART_LIGHT_GRAY);
        gradient.addColorStop(0, CHART_DARK_GRAY);
        chart.getDatasetMeta(0).data.forEach(dataPoint => {
            if (dataPoint.active) {
                ctx.beginPath();
                ctx.strokeStyle = gradient;
                ctx.moveTo(dataPoint.x, top);
                ctx.lineTo(dataPoint.x, bottom);
                ctx.stroke();
            }
        });
    }
};

//triggered on touchEnd on mobile
export const hideAfterMouseUp: Plugin = {
    id: "hideAfterMouseUp",
    afterEvent(chart, args) {
        if (args.event.type === "mouseup") {
            chart.setActiveElements([]);
            chart.update();
        }
    }
};

//for some reason if you add these settings to the chart options the line graph + fill turns black, so we're doing it in a plugin
export const greenGradient: Plugin = {
    id: "greenGradient",
    afterInit(chart) {
        const gradient = chart.ctx.createLinearGradient(0, 130, 0, 7); //chart top and bottom y values, not available before render
        gradient.addColorStop(1, CHART_FILL_GREEN);
        gradient.addColorStop(0, CHART_TRANSPARENT_GREEN);
        chart.data.datasets[1].backgroundColor = gradient;
        chart.data.datasets[1]["fill"] = "start";
    }
};